import { AnalyzeServiceProviderUnitPatternsResponse, GetServiceProviderUnitOverviewResponse } from '../../api-service/clients';
import { moduleClientFactory } from '../../api-service/module-client-factory';

const overviewClient = moduleClientFactory.createServiceProviderUnitOverviewClient();

export function getServiceProviderUnitOverview(serviceProviderUnitId: string): Promise<GetServiceProviderUnitOverviewResponse> {
  return overviewClient.getServiceProviderUnitOverview({ serviceProviderUnitId });
}

export function analyzeServiceProviderUnitPatterns(serviceProviderUnitId: string): Promise<AnalyzeServiceProviderUnitPatternsResponse> {
  return overviewClient.analyzeServiceProviderUnitPatterns({ serviceProviderUnitId });
}
